import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function ReturnChip({
  label = "From Health",
  to = "/model-drift-monitoring",
}: {
  label?: string;
  to?: string;
}) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1.5 rounded-full border border-amber/50 bg-amber-dim/40 px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.14em] text-amber transition-colors hover:bg-amber-dim"
    >
      <ArrowLeft className="h-3 w-3" />
      {label}
    </Link>
  );
}
